import { z } from 'zod';
export const NudgeRecordingRequestSchema = z.object({
    targetUserId: z.string(),
    processId: z.string(),
    stepId: z.string().optional(),
    message: z.string().min(1).max(500)
});
export const NudgeRecordingResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=nudge-recording.schema.js.map